
export enum PositionTypes {
  CUSTOM = 'custom',
  TEXT = 'text',
  HEADLINE = 'headline',
  HORIZONTAL_RULE = 'horizontalRule',
  PAGE_BREAK = 'pageBreak',
  SUBTOTALS = 'subtotals',
  ARTICLE = 'article',
  INVOICE = 'invoice',
  TIMETRACKING = 'time',
  MITE = 'mite',
  TOTAL_DISCOUNT = 'totalDiscount',
  TOTAL_SURCHARGE = 'totalSurcharge',
}

export const SpecialPositionTypes = [
  PositionTypes.HEADLINE,
  PositionTypes.HORIZONTAL_RULE,
  PositionTypes.PAGE_BREAK,
  PositionTypes.TEXT,
  PositionTypes.SUBTOTALS,
]
